import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row\">\n  <div class=\"column small-12 popup-header-module__container\">\n  <p class=\"popup-header-module__container__logo\">\n    <img src=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"bankLogo") || (depth0 != null ? lookupProperty(depth0,"bankLogo") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"bankLogo","hash":{},"data":data,"loc":{"start":{"line":32,"column":14},"end":{"line":32,"column":28}}}) : helper)))
    + "\" alt=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"bankLogoAlt") || (depth0 != null ? lookupProperty(depth0,"bankLogoAlt") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"bankLogoAlt","hash":{},"data":data,"loc":{"start":{"line":32,"column":35},"end":{"line":32,"column":52}}}) : helper)))
    + "\" />\n  </p>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"showEsVersion")),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":34,"column":4},"end":{"line":36,"column":11}}})) != null ? stack1 : "")
    + "  </div>\n</div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"langLink") || (depth0 != null ? lookupProperty(depth0,"langLink") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"langLink","hash":{},"data":data,"loc":{"start":{"line":35,"column":8},"end":{"line":35,"column":24}}}) : helper))) != null ? stack1 : "")
    + "\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\n<script>\n  function stickyFooter() {\n    var windowSize = window.innerHeight;\n    var contentSize = document.querySelector('body').offsetHeight;\n    var footer = document.querySelector('#globalFooterModule');\n    if (footer) {\n      if (windowSize > contentSize) {\n        footer.classList.add('sticky-footer');\n      } else {\n        footer.classList.remove('sticky-footer');\n      }\n    }\n  }\n\n  stickyFooter();\n\n  window.addEventListener('resize', function() {\n    stickyFooter();\n  });\n</script>\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"copy") : depth0),{"name":"with","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":28,"column":0},"end":{"line":39,"column":9}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.home-loans.modules/popup-header-module",
  "version": "1.0.1",
  "id": "popupHeaderModule",
  "containerID": "homeLoansPopupHeaderModule",
  "moduleName": "home-loans-popup-header-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "popup-header-module",
  "data": {
    "init": "PopupHeaderModule",
    "options": {}
  },
  "moduleParams": [{
    "name": "color",
    "type": "string",
    "description": "This parameter controls the general color scheme of module. The default is blue, but you can also choose red or green.",
    "default": "blue",
    "values": ["red", "green", "blue"]
  }, {
    "name": "showEnVersion",
    "type": "boolean",
    "values": [true, false],
    "default": true,
    "description": "Show the English version if there is one"
  }, {
    "name": "showEsVersion",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "Show the spanish version if there is one"
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0"
  },
  "stores": []
};

/**
 * Implementation of the popup-header-module module.
 * @copyright 2018-11-26
 * @since 11/26/2018, 11:25:09 AM
 * @author Renzo Gaspary
 * @file
 */

/**
 * The PopupHeaderModule Sparta Module.
 * An extremly minimal header module for the popup pages
 * @export
 * @class PopupHeaderModule
 * @extends Module
 */
class PopupHeaderModule extends Module {
  /**
   * Initialize the module
   * @method constructor
   * @param {object} options options object
   * @param {object} context context object
   * @returns {void}
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }

  /**
   * @method init
   * @desc Initialize module
   * @memberof PopupHeaderModule
   * @returns {void}
   */
  init() {}
}
registerModuleClass({
  moduleClass: PopupHeaderModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { PopupHeaderModule as default, moduleConfig };
